import { z } from 'zod';

/**
 * Schema for a single checkout disclosure object
 */
const checkoutDisclosureSchema = z.object({
    /**
     * The name of the disclosure (this will follow <model> to form the title of the disclosure,
     * like 'Halcyon <checkoutDisclosure.name>')
     */
    name: z.string().min(1, 'Name is required'),
    /**
     * Will be injected as HTML so you can include links and what not.
     * The description of the disclosure of the form 'You acknowledge and agree that ...'
     */
    description: z.string().min(1, 'Description is required'),
});
/**
 * Schema for an array of checkout disclosures
 */
const checkoutDisclosuresSchema = z.array(checkoutDisclosureSchema);

export { checkoutDisclosureSchema, checkoutDisclosuresSchema };
//# sourceMappingURL=CheckoutDisclosures.js.map
